import React from 'react';


const About = () => {
    
    return (
        <div >
            <h2>hello</h2>
        </div >
    );
};

export default About;